import intl from "react-intl-universal";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {LocationGqlProvider} from "../../stores/reliability/LocationGqlProvider";
import {snackBarRef} from "../../stores/snackbarRef";

export const deleteLocation = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string,
    id: string,
): Promise<void> => {
    await new LocationGqlProvider({dataClientService, authService}, wsId).delete(id);
    snackBarRef.current?.enqueueSnackbar({
        message: intl.get('locations.delete.success').d('Location deleted'),
    });
};
